export default __webpack_public_path__ + "static/footer-logo-9a01c74d358ab2956ebfd8e2a34c89ea.svg";